import React, { FocusEventHandler } from "react"
import { Comune } from "../../generated"
import { Autocomplete } from "../../common/components/autocompleteInput"
import Actions from "../ComuniActions";
import { formGroup } from "../../common/components/formGroup";

interface Props {
    error?: string;
    onChange: (comune: Comune | null) => void;
    hidden?: boolean;
    name?: string;
    placeholder?: string;
    label?: string;
    style?: React.CSSProperties;
    readOnly?: boolean;
    value?: Comune | string;
    required?: boolean;
    onFocus?: FocusEventHandler;
    onBlur?: FocusEventHandler;
}

export const ComuniAutocomplete = formGroup((props: Props) => {

    var component = (
        <Autocomplete
            style={props.style}
            name={props.name}
            label={props.label || "Comune"}
            error={props.error}
            onChange={props.onChange}
            textSelector={x => `${x.nomeComune} - ${x.cap} (${x.provincia})`}
            idSelector={x => x.codFisComune}
            required={props.required}
            onBlur={props.onBlur}
            onFocus={props.onFocus}
            value={typeof props.value == "string" ? props.value : props.value?.codFisComune}
            ActionsGet={Actions.get}
            ActionsSearch={literal => Actions.search(literal).then(({ comuni }) => comuni!)}
            readOnly={props.readOnly}
        />
    );
    if (props.hidden === true) {
        component = (<div />);
    }
    return (component);
})
